
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/sentry.client.config.ts")
            }
          });